// extracted by mini-css-extract-plugin
export var chevronIcon = "_7f-2";
export var teamName = "_7f-1";
export var teamSwitcherButton = "_7f-0";